// extracted by mini-css-extract-plugin
module.exports = {"container":"CubbyMenu_container__1JRcg","bodyWrapper":"CubbyMenu_bodyWrapper__1WMRh","button":"CubbyMenu_button__3-0QL","buttonText":"CubbyMenu_buttonText__2Qz26"};